module.exports = __webpack_public_path__ + "img/teleoperador.5526902b.svg";